import { Box, Typography } from "@mui/material";
import DownloadIcon from "assets/icons/dashboard/DownloadIcon";
import PropTypes from "prop-types";

interface DoctorSelectorProps {
  doctorName?: string;
}

const DoctorSelector: React.FC<DoctorSelectorProps> = ({
  doctorName = "Dr. Johnson",
}) => {
  return (
    <Box className="flex items-center gap-3">
      <Typography
        variant="body1"
        sx={{
          color: "#1B1B22",
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        Viewing {doctorName}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          borderRadius: "28px",
          width: "56px",
          height: "56px",
          justifyContent: "center",
          "&:hover": {
            backgroundColor: "#E8E8E9",
          },
        }}
      >
        <DownloadIcon />
      </Box>
    </Box>
  );
};

DoctorSelector.propTypes = {
  doctorName: PropTypes.string,
};

export default DoctorSelector;
